
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/lessons-you-can-create-as-an-esl-ell-teacher-with-curipod",
      function () {
        return require("private-next-pages/c/blog-posts/lessons-you-can-create-as-an-esl-ell-teacher-with-curipod.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/lessons-you-can-create-as-an-esl-ell-teacher-with-curipod"])
      });
    }
  